import { render, staticRenderFns } from "./fancy-ad.vue?vue&type=template&id=2b7f8f5d&scoped=true&"
import script from "./fancy-ad.vue?vue&type=script&lang=js&"
export * from "./fancy-ad.vue?vue&type=script&lang=js&"
import style0 from "./fancy-ad.vue?vue&type=style&index=0&id=2b7f8f5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f8f5d",
  null
  
)

export default component.exports